import { LoopNodeData } from "src/constants/NodeDataTypes";
import { SearchableField } from "src/flowGraph/canvasSearch/extractNodeFields";
import {
  extractClauses,
  extractInputMappings,
  extractWithPrefix,
} from "src/flowGraph/canvasSearch/nodesExtractors/utils";

export const extractLoopFields = (data: LoopNodeData): SearchableField[] => {
  return [
    data.target_list_expression,
    ...extractInputMappings(data.input_mappings),
    extractWithPrefix(data.output_destination_list_expression),
    ...extractClauses(data.break_condition.clauses),
  ];
};
